<div class="myCartBackground" [ngClass]="{'animated slideInRight' : widthGreater600, 'changeBgColor' : !cartItems.length}" *ngIf="showMyCart"></div>

<div class="myCartBg" [ngClass]="{'animated slideInRight' : widthGreater600}" *ngIf="showMyCart && !cartItems.length" style="min-height: 100vh;">
  <div class="titleBg">
    <h2>My Cart</h2>
    <img src="assets/images/my-cart-cross.svg" width="18" height="18" (click)="closeMyCart()">
  </div>

  <h2 class="emptyCart">Your cart is empty!</h2>

  <button class="checkOutButton" routerLink="/" (click)="closeMyCart()">browse menu</button>
</div>

<div class="myCartBg" [ngClass]="{'animated slideInRight' : widthGreater600}" *ngIf="showMyCart && cartItems.length">
  <div class="titleBg">
    <h2>My Cart</h2>
    <img src="assets/images/my-cart-cross.svg" width="18" height="18" (click)="closeMyCart()">
  </div>

  <div *ngFor="let items of cartItems" class="itemLoopBg">

    <div class="topTransparentLayer" *ngIf="items.datePast" (click)="removeExpiredOrder(items)">
      <p>Order date expired. Tap to remove</p>
    </div>

    <div class="itemsTop">
      <div class="dateBg">
        <h2 [ngClass]="{'redText': items.datePast}">{{items.date | date: 'EEE, MMM d'}}</h2>
        <p *ngIf="items.items.length === 1">{{items.items.length}} Item</p>
        <p *ngIf="items.items.length > 1">{{items.items.length}} Items</p>
      </div>
      <p class="deliveryInstructions">Delivery will be made between 6 pm<br>on {{items.previousDayDate | date: 'MMM d'}} and 6 am on {{items.date | date: 'MMM d'}}</p>
    </div>

    <div class="itemsBg">
      <div class="itemBg" *ngFor="let item of items.items">
        <div class="itemBackground">
          <div class="imageBg">
            <img src="{{environment.s3ItemThumbImage}}{{item.zf_image_web}}">
          </div>
          <div class="textBg">
            <h3>{{item.zf_name}}</h3>
            <div class="textBottom">
              <div class="col-6 p-0 itemQuantityBg">
                <i class="fa fa-minus" (click)="itemMinus(item, items.date)"></i>
                <p>{{item.count}}</p>
                <i class="fa fa-plus" (click)="itemPlus(item, items.date)" [ngClass]="{'pointer-event-none': item.count >= 999}"></i>
              </div>
              <span class="col-5 pr-0">{{item.zf_price * item.count | currency}}</span>
            </div>
          </div>
        </div>
        <p class="errorText" *ngIf="item.cantRemoveFreeItem" style="font-family: MontserratLight; font-size: 13px;">This item is given free to you. You can remove this item by removing promo code.</p>
      </div>
    </div>

    <div class="totalBg">
      <div class="total">
        <p class="col-7 p-0">Total of the Day:</p>
        <h3 class="col-5 p-0" [ngClass]="{'errorClass': items.dayTotal < 25}">{{items.dayTotal + promoFreeItemDiscount | currency}}</h3>
      </div>
      <p class="minimumDailyError" *ngIf="items.dayTotal < 25">Add {{25 - items.dayTotal | currency}} to reach minimum daily order amount.</p>
      <a class="col-12 p-0 mt-4 mb-4" routerLink="/" (click)="closeMyCart(); myCartSelectedDateClick(items.date)">Add Another Item to This Date!</a>
    </div>
  </div>

  <!-- TODO My Cart you may enjoy -->
  <div class="youMayEnjoyBg" *ngIf="youMayEnjoyItems.length && !hideSuggested">
    <div class="loader-bg col-12" *ngIf="showYouMayEnjoyLoader" style="position: absolute; left: 0;">
      <span class="loader" style="width: 35px; height: 35px; top: 45%; border: 3px solid #FED130;"><span class="loader-inner"></span></span>
    </div>
    <h2 class="col-12 p-0">You May Also Enjoy:</h2>
    <div class="itemBg">
      <div class="imageBg">
        <img src="{{environment.s3ItemThumbImage}}{{youMayEnjoyItemsShow.image}}">
      </div>
      <div class="textBg">
        <h3>{{youMayEnjoyItemsShow.name}}</h3>
        <div class="priceBg">
          <div class="priceButton" (click)="youMayItemPlus(youMayEnjoyItemsShow)">
            <i class="fa fa-plus"></i>
            <span>{{youMayEnjoyItemsShow.price | currency}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="dotsBg" *ngIf="youMayEnjoyItems.length > 1">
      <img src="assets/images/item-slider-dot_1.svg" width="30" height="10" *ngIf="itemIndex === 0;">
      <img src="assets/images/item-slider-dot_2.svg" width="30" height="10" *ngIf="itemIndex === 1">
    </div>
  </div>

  <div class="promoAndSummaryBg">

    <!--TODO My Cart Promo Code-->
    <a class="promoButtons" *ngIf="!showPromoCodeForm && !showPromoCodeApplied" (click)="showPromoCodeForm = true; invalidPromo = false;">add a promo code</a>

    <div class="promoBg" *ngIf="showPromoCodeForm && !showPromoCodeApplied">
      <form [formGroup]="addPromoForm">
        <input formControlName="promocode" name="promocode" maxlength="50" type="text" id="promocode" #promocode required
               autocomplete="off" placeholder="Enter Promo Code" autofocus [ngClass]="{'inputRedBorder' : invalidPromo}">
        <p *ngIf="invalidPromo" class="errorMessageTwo">{{errorMessage}}</p>
        <div class="promoButtonsBg">
          <div class="col-7 pl-0">
            <button type="submit" class="btn-green col-12" (click)="applyPromoCodeClick()" [disabled]="addPromoForm.invalid"
                    [ngClass]="{'btn-green-disabled' : addPromoForm.invalid}" style="height: 45px; line-height: 45px;">apply</button>
          </div>
          <div class="col-4 p-0">
            <a class="cancelBtn" (click)="cancelPromoCode()">Cancel</a>
          </div>
        </div>
      </form>
    </div>

    <div class="myCartPromoApplied pul-right" *ngIf="showPromoCodeApplied">
      <span class="discountApplied" *ngIf="appliedPromoObject.discountType === 'amount'">{{appliedPromoObject.discountValue | currency}} OFF</span>
      <span class="discountApplied" *ngIf="appliedPromoObject.discountType === 'free'" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 70%; float: left;">Free {{appliedPromoObject.freeItem.zf_name}}</span>
      <span class="discountApplied" *ngIf="appliedPromoObject.discountType === 'percentage'">{{appliedPromoObject.discountPercentageValue}}% OFF</span>
      <a class="pull-right" (click)="removePromoFunction()">Remove</a>
      <p *ngIf="showMinimumSpendError && !freeItemNotAvailable" style="color: #A53736 !important;">{{minimumSpendErrorMessage}}</p>
      <p class="mb-0" *ngIf="!showMinimumSpendError && !freeItemNotAvailable && (appliedPromoObject.discountType === 'amount' || appliedPromoObject.discountType === 'percentage')">
        Discount has been applied to your order</p>
      <p *ngIf="!showMinimumSpendError && freeItemNotAvailable" style="color: #A53736 !important;">{{freeItemNotAvailableMessage}}</p>
      <p class="mb-0" *ngIf="appliedPromoObject.discountType === 'free' && (!showMinimumSpendError && !freeItemNotAvailable)">
        <span style="max-width: 100%; float: left; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{appliedPromoObject.freeItem.zf_name}}</span> <span style="float: left;">has been added to your cart and the equivalent discount has been applied to your order total.</span>
      </p>
    </div>
    <!--Promo Code-->

    <!--TODO My Cart Summary-->
    <div class="summaryBg">
      <h2 class="orderSummaryTitle">Order Summary</h2>
      <div class="textRow" style="background: #FAFAFA; cursor: pointer;" (click)="showOrderTotalDetail = !showOrderTotalDetail;">
        <p>Order Total <i class="fa" [ngClass]="{'fa-angle-down': !showOrderTotalDetail, 'fa-angle-up': showOrderTotalDetail}"></i></p>
        <p>{{orderTotal + promoFreeItemDiscount | currency}}</p>
      </div>
      <div class="orderTotalDetailBg" *ngIf="showOrderTotalDetail">
        <div class="innerRow" *ngFor="let items of cartItems" style="background: #ffffff !important;">
          <p>{{items.date | date: 'EEE, MMM d'}}</p>
          <p [ngClass]="{'textRedClass': items.dayTotal < 25}">{{items.dayTotal | currency}}</p>
        </div>
      </div>

      <div class="textRow" *ngIf="showPromoCodeApplied && !freeItemNotAvailable && !showMinimumSpendError">
        <p>Promo Code</p>
        <p style="color: #F4A130;">-{{appliedPromoObject.discountValue | currency}}</p>
      </div>
      <div class="textRow" style="cursor: pointer;" (click)="showDeliveryFeeDetail = !showDeliveryFeeDetail;">
        <p>Delivery Fee Total <i class="fa" [ngClass]="{'fa-angle-down': !showDeliveryFeeDetail, 'fa-angle-up': showDeliveryFeeDetail}"></i></p>
        <p>{{deliveryFeeTotal  | currency}}</p>
      </div>
      <div class="orderTotalDetailBg" *ngIf="showDeliveryFeeDetail">
        <div class="innerRow" *ngFor="let items of cartItems" style="background: #ffffff !important;">
          <p>{{items.date | date: 'EEE, MMM d'}}</p>
          <p>{{singleDayDeliveryFeeTotal | currency}}</p>
        </div>
      </div>

      <div class="textRow" style="background: #FAFAFA;">
        <p>Tax</p>
        <p>{{taxAmount | currency}}</p>
      </div>

      <div class="grandTotalRow">
        <p>Grand Total</p>
        <span>{{grandTotal + deliveryFeeTotal + taxAmount + promoFreeItemDiscount | currency}}</span>
      </div>
    </div>
  </div>
  <!--My Cart Summary-->

  <div class="addAnotherItemBg" routerLink="/" (click)="closeMyCart(); addAnotherDeliveryClick()">
    <h2>Add Another Delivery to This Order!</h2>
    <p>Click here to return to the Main Menu, choose another date and add the items you want!</p>
  </div>

  <button class="checkOutButton" (click)="continueCheckOutClick()" routerLink="/checkout/review-order" [disabled]="disableCheckOutButton || showMinimumSpendError || freeItemNotAvailable" [ngClass]="{'btn-green-disabled' : disableCheckOutButton || showMinimumSpendError || freeItemNotAvailable}">continue to checkout</button>

</div>

<!-- footer -->
<app-footer *ngIf="showMyCart"></app-footer>
<!-- footer -->



// WEBPACK FOOTER //
// ./src/app/modules/shared/my-cart/my-cart.component.html